export const GOOGLE_CONTACTS_IMPORT_ENABLED = false;

export function getContactImportAvailability() {
  return {
    googleEnabled: GOOGLE_CONTACTS_IMPORT_ENABLED,
    googleLabel: GOOGLE_CONTACTS_IMPORT_ENABLED ? 'Import Google' : 'Google import: Coming in next update',
    manualContactsEnabled: true,
    csvImportEnabled: true
  };
}
